import {FormField} from "../form-field/form-field";
import SignaturePad from "signature_pad";

export class FormFieldSignature extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$signatureCanvas = null;
        this.$signatureCanvasElement = null;
        this.$hiddenValue = null;
        this.$config = {};
    }

    getVal(){
        if(this.signaturePad.isEmpty()){
            return null;
        }
        return JSON.stringify(this.signaturePad.toData());
    }

    setVal(val,noEvent){
        if(val){
            try{
                const data = JSON.parse(val);
                if(Array.isArray(data) && data.length){
                    this.signaturePad.fromData(data);
                }else{
                    this.signaturePad.clear();
                }
            }catch(e){
                console.warn("Error cargando firma:",e);
                this.signaturePad.clear();
            }
        }else{
            this.signaturePad.clear();
        }
        this.$hiddenValue.val(val || "");
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    updateHidden(){
        const val = this.getVal();
        this.$hiddenValue.val(val===null?"":val);
        this.$root.trigger("formField:changeVal");
    }

    resizeCanvas(){
        const canvas = this.$signatureCanvasElement;
        if(!canvas.offsetWidth || !canvas.offsetHeight){
            return;
        }

        const ratio = Math.max(window.devicePixelRatio || 1,1);
        const data = this.signaturePad.isEmpty()?null:this.signaturePad.toData();

        canvas.width = canvas.offsetWidth*ratio;
        canvas.height = canvas.offsetHeight*ratio;
        canvas.getContext("2d").scale(ratio,ratio);

        if(data){
            this.signaturePad.fromData(data);
        }
    }

    observeVisibility(){
        const canvas = this.$signatureCanvasElement;
        if(!canvas){
            return;
        }
        const observer = new ResizeObserver(() => {
            if(canvas.offsetWidth && canvas.offsetHeight){
                this.resizeCanvas();
                observer.disconnect();
            }
        });
        observer.observe(canvas);
    }

    ready(){
        super.ready();
        this.$signatureCanvas = $(this.$root).find(this.scope+"__signature");
        this.$signatureCanvasElement = this.$signatureCanvas[0];
        this.$hiddenValue = this.$root.find("input[type='hidden'][name='"+this.$signatureCanvas.data("name")+"']");
        const configStr = this.$signatureCanvas.data("config");
        if(configStr){
            try{
                this.$config = typeof configStr==="string"?JSON.parse(configStr):configStr;
            }catch(e){
                console.warn("Error parsing canvas config:",e);
                this.$config = {
                    backgroundColor: "rgba(255, 255, 255, 0)",
                    penColor: "rgb(0, 0, 0)"
                };
            }
        }

        // Init Signature Pad
        this.signaturePad = new SignaturePad(this.$signatureCanvasElement,this.$config);
        const initialVal = this.$hiddenValue.val();
        if(initialVal){
            this.setVal(initialVal,true);
        }

        this.observeVisibility();
        this.$signatureCanvasElement.addEventListener("pointerup",() => this.updateHidden());
        this.$signatureCanvasElement.addEventListener("blur",() => this.updateHidden());

        // Controls
        this.$root.find(this.scope+"__clear-signature").on("click",() => {
            this.signaturePad.clear();
            this.$hiddenValue.val("");
        });
    }
}
